module.exports = __webpack_public_path__ + "img/cert-iso.f9d83ebb.png";